import React from 'react'
import { Drawer } from 'antd'
import BoostersList from './BoostersList'

const QuestionRubricToolsDrawer = ({ questionRubric, onClose }) => {
    if (!questionRubric) return null

    return (
        <Drawer
            title={`Tools for: ${questionRubric.name || 'Rubric'}`}
            open={!!questionRubric}
            onClose={onClose}
            width={560}
            destroyOnClose
        >
            <BoostersList questionRubricId={questionRubric.id} />
        </Drawer>
    )
}

export default QuestionRubricToolsDrawer

